<template>
  <div class="step5">
    <div class="warning">
      请再次确认您将注销
      <div
        style="
          display: initial;
          text-decoration: none;
          color: rgb(255, 102, 0);
          font-weight: 700;
        "
      >
        心动账号(ID:{{ user_id }})
      </div>
      ，账号注销后您将无法以该账号登录和使用如下心动产品，且注销后不可恢复：
    </div>
    <!-- <Tips class="mt-2"> -->
    <!-- <template v-slot:content> -->
    <div class="no-content" v-if="gameList.length === 0">
      该账号暂未使用心动任意产品
    </div>
    <div class="game-list" v-else>
      <div class="game-item" v-for="(item, idx) in gameList" :key="idx">
        {{ item }}
      </div>
    </div>
    <!-- </template> -->
    <!-- </Tips> -->
    <Button @click="confirmDelete" class="next-step" text="确认提交" />
    <Popup v-model="isShowConfirm" class="confirm-pop">
      <div class="title">注销心动帐号</div>
      <div class="confirm-str">
        请输入"<a>Delete</a>"并确认提交注销心动账号申请
      </div>
      <Input
        class="delete-input input mt-1"
        :valid="true"
        :value="deleteStr"
        message="您的输入有误"
        ref="confirm"
        :onInputChange="onInputChange"
      />
      <div class="confirm-container">
        <Button
          @click="confirmDelete"
          class="cancel"
          text="取消"
        />
        <Button
          @click="confrimNextStep"
          class="confirm"
          text="确认"
        />
      </div>
    </Popup>
  </div>
</template>

<script>
import Button from '../../components/button'
import Input from '../../components/input'
import Api from '../../common/api'
import { Toast, Popup } from 'vant'

export default {
  props: {
    nextStep: {
      type: Function,
      default: () => {}
    },
    isShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      validStatus: true,
      deleteStr: '',
      isShowConfirm: false,
      placeHolder: '请输入你的心动 ID',
      value: '',
      isShowDialog: false,
      gameList: [],
      user_id: '',
      queryIDContentStyle: {
        width: '89%',
        height: '90%',
        border: '1px solid #E6E6E6',
        'border-radius': '5px'
      },
      queryIDContentTitle: {
        height: '58px',
        'border-bottom': '1px solid #8a8a8a1f',
        'text-align': 'center',
        'font-family': 'PingFang SC',
        'font-style': 'normal',
        'font-weight': '500',
        'font-size': '16px',
        'line-height': '58px',
        /* identical to box height, or 162% */
        'letter-spacing': '4.93506e-09px',
        color: '#333333'
      }
    }
  },
  components: {
    Button,
    Popup,
    Input
    // Dialog
  },
  mounted () {
    if (!window.userData) {
      this.$router.push({
        name: 'Home',
        hash: '#step1',
        params: { index: this.stepsIndex + 1 }
      })
    }
    window.gameList.forEach((item) => {
      this.gameList.push(item)
    })
    this.user_id = window.user_id
  },
  methods: {
    confrimNextStep () {
      if (this.deleteStr === 'Delete') {
        this.$refs.confirm.validStatus = true
        this.goToNextStep()
      } else {
        console.log('there')
        this.$refs.confirm.validStatus = false
      }
    },
    toggleDialog () {
      this.isShowDialog = !this.isShowDialog
    },
    confirmDelete () {
      this.isShowConfirm = !this.isShowConfirm
      if (!this.isShowConfirm) {
        this.deleteStr = ''
      }
    },
    goToNextStep () {
      const data = {
        user_id: window.userData.user_id,
        realname: window.userData.realname,
        realid: window.userData.realid,
        country_code: window.userData.country_code,
        mobile: window.userData.mobile,
        sms_code: window.userData.sms_code
      }
      Api.submitLogout(data)
        .then((res) => {
          if (res.code === 1) {
            window.logOut = true
            setTimeout(() => {
              this.$emit('nextStep')
            }, 300)
          } else {
            Toast(res.msg)
            window.logOut = null
          }
        })
        .catch(() => {
          window.logOut = null
        })
    },
    onInputChange (e) {
      this.$refs.confirm.validStatus = true
      this.deleteStr = e
      if (e.length === 0) {
        this.deleteStr = ''
      }
    }
  }
}
</script>

<style lang="less" scoped>
.step5 {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .no-content {
    margin-top: 20px;
    margin-bottom: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    text-align: center;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    /* identical to box height, or 171% */

    text-align: center;
    letter-spacing: -0.2px;

    color: #5c5c5c;
    background: #f9f9fb;
    border: 1px solid #edf1f1;
    box-sizing: border-box;
    border-radius: 5px;
  }
  .game-list {
    background: #f9f9fb;
    border: 1px solid #edf1f1;
    box-sizing: border-box;
    border-radius: 5px;
    width: 100%;
    padding-left: 20px;
    padding-right: 20px;
    margin-top: 20px;
    .game-item {
      border-bottom: 1px solid #e6e6e6;
      // height: 56px;
      line-height: 24px;
      text-align: left;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      word-break: break-all;
      width: 100%;
      padding: 16px 0 16px 0;
      // line-height: 24px;
      /* identical to box height, or 171% */

      letter-spacing: 4.93507e-9px;

      /* 黑色 */

      color: #333333;
    }
    .game-item:last-child {
      border-bottom: none !important;
    }
  }
  .warning {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 25px;
    text-align: justify;
    margin-top: 16px;

    /* 正文 */

    color: #5c5c5c;
  }
  .next-step {
    margin-top: 20px;
    /* VI */
    background: #ff6600;
    border-radius: 5px;
    color: #fff;
    font-size: 14px;
    padding-top: 9px;
    padding-bottom: 9px;
    border: 0;
    height: 42px;
  }
}
@media screen and (max-width: 1280px) {
  .confirm-pop {
    width: 89%;
  }
}
@media screen and (min-width: 1280px) {
  .confirm-pop {
    width: 570px !important;
  }
}
.confirm-pop {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 5px;
  // width: 89%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // padding: 20px;
  .title {
    width: 100%;
    height: 58px;
    font-family: PingFang SC;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 58px;
    /* identical to box height, or 162% */

    letter-spacing: 4.93506e-9px;

    color: #333333;
    border-bottom: 1px solid #e6e6e6;
  }
  .confirm-str {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    a {
      color: #ff6600;
    }
  }
  .delete-input {
    margin-top: 8px;
    margin-left: 20px;
    margin-right: 20px;
    // background: #ffffff;
    // border: 1px solid #e6e6e6;
    // box-sizing: border-box;
    // border-radius: 3px;
    // height: 44px;
    width: 78%;
    .rule{
      text-align: left;
    }
  }
  .confirm-container {
    // margin-left: 20px;
    // margin-right: 20px;
    width: 78%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 20px;
    button {
      background: rgb(255, 255, 255);
      border-radius: 5px;
      width: 48.8%;
      height: 42px;
      border: 1px solid rgb(178, 178, 178);
      color: rgb(178, 178, 178);
    }
    .cancel {
    }
    .confirm {
      background: rgb(255, 102, 0);
      border-radius: 5px;
      width: 48.8%;
      height: 42px;
      color: rgb(255, 255, 255);
    }
  }
}
</style>
